import APIS from "../../constant/EndPoint";
import { classNames } from "../../utils/classNames";

//@ts-ignore
import { tw } from "@careinfo/tailwind";

import { IFilterDanfe } from "./OrderList";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";
import { useSearchParams } from "react-router-dom";
interface Props {
  register: UseFormRegister<IFilterDanfe>;
  errors: FieldErrors<IFilterDanfe>;
  setValue: UseFormSetValue<IFilterDanfe>;
  getValues: UseFormGetValues<IFilterDanfe>;
  reset: UseFormReset<IFilterDanfe>;
  watch: UseFormWatch<IFilterDanfe>;
  clearErrors: UseFormClearErrors<IFilterDanfe>;
  control: Control<IFilterDanfe, any>;
  isFilterVisible: boolean;
}

const OrderFilter = ({
  register,
  errors,
  setValue,
  getValues,
  reset,
  watch,
  clearErrors,
  control,
  isFilterVisible,
}: Props) => {
  return (
    <div
      className={classNames(
        isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-3 items-center gap-x-4 mx-4`}>
          <ComboboxFilter<IFilterDanfe>
            url={APIS.BRANCHS}
            queryKey={"branch"}
            params={{
              is_active: true,
            }}
            name={"pickup_branch"}
            control={control}
            label={"Pickup Branch"}
            placeholder={"Select Pickup Branch"}
          />
          <ComboboxFilter<IFilterDanfe>
            url={APIS.LOCATIONS}
            queryKey={"destination"}
            params={{ level: 3, is_active: true }}
            name={"destination"}
            control={control}
            label={"Destination City"}
            placeholder={"Select Destination City"}
          />

          <DateRangePicker
            label={"Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxFilter<IFilterDanfe>
            url={APIS.DELIVERY_PARTNER}
            queryKey={"delivery-partner"}
            params={{is_active: true}}
            name={"delivery_partner__slug"}
            control={control}
            label={"Delivery Partner"}
            placeholder={"Select Delivery Partner"}
          />

          <button
            className={tw`absolute -top-5 right-5`}
            onClick={() => reset()}
          >
            Reset
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default OrderFilter;
